module.exports = __webpack_public_path__ + "static/media/logout.48a12d19.svg";